import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { useTranslation } from 'react-i18next';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { IAccessory } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const AccessoriesTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IAccessory[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  const { t } = useTranslation();

  const hasEditPermission = hasPermission(['accessories.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) => !header ? null : (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item ${hasEditPermission && 'clickable'} has_logo vehicle_makes`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/accessories/create-accessory/${item.id}`, navigate);
                }}
              >
                <div className="column">{item.id}</div>
                <div className="column">{item?.code || '-'}</div>
                <div className="column">
                  <div className="capitalize">{item?.name?.en || '-'}</div>
                </div>
                <div className="column">
                  <div className="capitalize">{item?.new_or_used || '-'}</div>
                </div>
                <div className="column">{item?.price || '-'}</div>
                {/* <div className="column">{item?.vehicle_model?.name || '-'}</div>
                <div className="column">{item?.variant?.display_name || '-'}</div> */}
                <div className="column">{item?.hidden ? t('yes') : t('no')}</div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/accessories/create-accessory/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                    <DeleteButton deleteRoute={`/admin/accessories`} queryKey='accessories' id={item.id}/>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default AccessoriesTableContainer;
